export default __webpack_public_path__ + "static/media/profile-bg.b6ae9af8.jpg";